"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var utils_1 = require("./utils");
var Chart_1 = __importDefault(require("../Chart"));
var BarChart = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'vertial' : _b, xAxisTitle = _a.xAxisTitle, yAxisTitle = _a.yAxisTitle, categories = _a.categories, stacking = _a.stacking, onClick = _a.onClick, series = _a.series, chartProps = __rest(_a, ["direction", "xAxisTitle", "yAxisTitle", "categories", "stacking", "onClick", "series"]);
    var theme = react_1.useTheme();
    var options = react_2.useMemo(function () { return utils_1.buildOptions({
        direction: direction,
        xAxisTitle: xAxisTitle,
        yAxisTitle: yAxisTitle,
        categories: categories,
        stacking: stacking,
        onClick: onClick,
        series: series,
        theme: theme,
    }); }, [
        direction,
        xAxisTitle,
        yAxisTitle,
        categories,
        stacking,
        onClick,
        series,
        theme,
    ]);
    return (react_1.jsx(Chart_1.default, __assign({}, chartProps, { options: options })));
};
exports.default = BarChart;
